import UserList from './user.list';
import UserCreate from './user.create';
import UserEdit from './user.edit';

export default {
  list: UserList,
  create: UserCreate,
  edit: UserEdit,
};
